import leeCoreLexExperiments from 'bundles/epic/clients/leeCoreLex';

/**
 * These namespaces and experiment utils are part of a paid engagement AI sprint effort.
 *
 * The impression point is intended to be when a learner enrolls in any course, including specializations.
 *
 * Read more in the PRD:
 * https://docs.google.com/document/d/13L3gnMCXidF0pzj-36HCw0oO8vpKBNItew8KxYHBDM4/edit?tab=t.4cqggequ4zau#heading=h.ekapz1jp03yd
 */

/**
 * Check if learner stats are enabled for a user.
 * EPIC Link: https://tools.coursera.org/epic/experiment/xlW3cStmEfC1iRKne8QPDw
 */
export function isShowLearnerStatsEnabled() {
  const treatment = leeCoreLexExperiments.preview('showLearnerStats');
  return treatment === 'all' || treatment === 'suppressed_emails';
}

/**
 * Impression for the learner stats experiment.
 * EPIC Link: https://tools.coursera.org/epic/experiment/xlW3cStmEfC1iRKne8QPDw
 */
export function impressIntoLearnerStats() {
  const treatment = leeCoreLexExperiments.get('showLearnerStats');
  return treatment === 'all' || treatment === 'suppressed_emails';
}

/**
 * This impression is for an A/A test to validate impressions before the experiment starts.
 * The result of this value should change no behavior. It can be safely removed once the A/A test is complete.
 * EPIC Link: https://tools.coursera.org/epic/experiment/LuS1vS0cEfCHlw4giApofQ
 */
export function impressionTestForShowLearnerStats() {
  return leeCoreLexExperiments.get('showLearnerStatsTest');
}
